import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { URLS } from '../config/urls';
import { AppProfile, Profile } from '../types/types';
import { WorkflowState } from '../state/state.state';
import { saveProfile } from '../state/state.actions';
import { AlertService } from 'projects/shared-new/src/lib/services-new/alert.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private store: Store<{ workflow: WorkflowState }>) {}

  private httpClient = inject(HttpClient);
  private alertService = inject(AlertService);

  getProfile(): void {
    this.httpClient.get<Profile>(URLS.PROFILE).subscribe({
      next: (profile) => {
        this.store.dispatch(saveProfile({ profile: profile }));
      },
      error: (error) => {
        this.alertService.error(
          'Oops! It seems like there was an issue loading your profile. Please try again.',
        );
      },
    });
  }

  setProfile(appProfile: AppProfile): void {
    this.httpClient
      .post<Profile>(URLS.PROFILE, { appProfile: appProfile })
      .subscribe({
        error: (error) => {
          this.alertService.error(
            'Oops! It seems like there was an issue saving your profile. Please try again.',
          );
        },
      });
  }
}
